/**
 * Created by mykurisu on 2017/8/14.
 */
import React from 'react';
import axios from 'axios';
import {Dialog, Toast} from 'react-weui'
import { getAccessToken } from '../../utils'
import { connect } from 'react-redux'
import {
    Page,
    Preload,
    WKError
} from '../../components'
import {
    ManageList,
    ManageHeader,
    BottomBtn
} from '../../components/liveroomLecturer'
import '../../css/page/LiveroomLecturerPage.css'
import errorImg from '../../images/no-source.png'
import { getWhiteList } from '../../api/module/gateway'
import { getPgcInviteInfo } from '../../api/module/manage'
import { parseError } from '../../api/util'

class liveroomlectureManage extends React.Component {

    constructor() {
        super();
        this.state = {
            init: false,
            whiteList: null,
            qrcodeDialog: {
                isShow: false,
                loading: false,
                timer: 0,
                errMsg: '',
            }
        }
    }

    componentDidMount() {
        let id = this.props.routeParams.liveroom_id;

        document.title = '直播间管理员';

        this.props.dispatch({
            type: 'LIVEROOM_ID_SAVE',
            payload: id
        });

        getWhiteList(Number(id)).then(res => {
            this.setState({
                whiteList: res
            })
        })
        axios.get(`/api/liveroom/${id}/simple_info?token=${getAccessToken()}`)
            .then((res) => {
                if (res.data.code === 0) {
                    this.props.dispatch({
                        type: 'LIVEROOMSETTINGINIT',
                        payload: res.data.data
                    });
                    this.setState({
                        init: true
                    })
                }
            }).catch((error) => {
                if (error.response && error.response.status === 404) {
                    this.props.dispatch({
                        type: 'ERROR_SHOW',
                        payload: {
                            tips: '网络连接出问题了。',
                            img: errorImg,
                            href: '/?st=liveroom_setting_manage_404',
                            btn: '去首页看看'
                        }
                    });
                } else if (error.response && error.response.status === 403) {
                    this.props.dispatch({
                        type: 'ERROR_SHOW',
                        payload: {
                            tips: '没有查看权限。',
                            img: errorImg,
                            href: '/?st=liveroom_setting_manage_403',
                            btn: '去首页看看'
                        }
                    });
                }
            });

        axios.get(`/api/liveroom/${id}/manager/list`)
            .then(res => {
                if (res.data.code === 0) {
                    this.props.dispatch({
                        type: 'LIVEROOM_MANAGE_INIT',
                        payload: res.data.data
                    })
                }
            }).catch((error) => {
                if (error.response && error.response.status === 404) {
                    this.props.dispatch({
                        type: 'ERROR_SHOW',
                        payload: {
                            tips: '网络连接出问题了。',
                            img: errorImg,
                            href: '/?st=liveroom_setting_manage_404',
                            btn: '去首页看看'
                        }
                    });
                } else if (error.response && error.response.status === 403) {
                    this.props.dispatch({
                        type: 'ERROR_SHOW',
                        payload: {
                            tips: '你没有查看此内容的权限。',
                            img: errorImg,
                            href: '/?st=liveroom_setting_manage_403',
                            btn: '去首页看看'
                        }
                    });
                }
            });
    }

    loadSetPgcInviteInfo(){
        this.setState({
            qrcodeDialog: {
                ...this.state.qrcodeDialog,
                isShow: true,
                loading: true,
            }
        })
        getPgcInviteInfo(this.props.routeParams.liveroom_id).then((res) => {
            clearTimeout(this.state.qrcodeDialog.timer)
            this.setState({
                qrcodeDialog: {
                    ...this.state.qrcodeDialog,
                    qrcode: res.qrcode,
                    loading: false,
                }
            })
        }).catch((err) => {
            let timer = setTimeout(() => {
                this.setState({
                    qrcodeDialog: {
                        ...this.state.qrcodeDialog,
                        errMsg: ''
                    }
                })
            },2000)
            this.setState({
                qrcodeDialog: {
                    ...this.state.qrcodeDialog,
                    loading: false,
                    errMsg: '查询失败:' + parseError(err),
                    timer
                }
            })

        })
    }

    render() {

        const { error } = this.props;
        if (error.showError) {
            return (
                <div style={{ background: '#fff', width: '100%', height: '100vh' }}>
                    <WKError />
                </div>
            )
        }

        const { liveroomManageInit, liveroom_id, liveroomInfo, account_id } = this.props;

        if (!liveroomManageInit || !this.state.init) {
            return <Preload />
        }

        const btnContent = {
            text: <div>
                添加管理员
                <div className={!this.state.whiteList ? 'weui-loading' : ''}/>
            </div>,
            method: () => {
                if (!this.state.whiteList) {
                    return
                }
                if (this.state.whiteList.is_pgc_liverooms) {
                    this.loadSetPgcInviteInfo()
                    return
                }
                location.assign(`/liveroom/${liveroom_id}/edit/manage/invite`)
                // window.location.href = Config.MAIN_URL + `/liveroom/invite_manager?liveroom_id=${liveroom_id}`
            }
        };
        return (
            <Page>
                <div className="liveroom-setting-manage-page">

                    <ManageHeader />

                    <ManageList />

                    {liveroomInfo.liveroom.account_id === account_id &&
                        <BottomBtn btnContent={btnContent} />
                    }

                    <Dialog type="ios" title='添加管理员' show={this.state.qrcodeDialog.isShow}
                            buttons={[
                                { label: '好的', onClick: () => {
                                        this.setState({
                                            qrcodeDialog: {
                                                ...this.state.qrcodeDialog,
                                                isShow: false,
                                            }
                                        })
                                    }}
                            ]}>
                        <div>
                            <p>对应用户扫描二维码后按指引操作，即可认证成为管理员</p>
                        </div>

                        <div>

                            <div className={'liveroom-manage-qrcode'}>
                                <img src={this.state.qrcodeDialog.qrcode}/>
                                <div className={this.state.qrcodeDialog.loading ? 'weui-loading' : ''}/>
                            </div>
                        </div>
                    </Dialog>
                    <Toast icon="warn" show={!!this.state.qrcodeDialog.errMsg}>{this.state.qrcodeDialog.errMsg}</Toast>
                </div>
            </Page>
        )
    }
}

export default connect(state => ({
    liveroomManageInit: state.liveroomSetting.liveroomManageInit,
    liveroom_id: state.liveroomSetting.liveroom_id,
    liveroomInfo: state.liveroomSetting.liveroomInfo,
    account_id: state.account.id,
    error: state.error,
}))(liveroomlectureManage)


// WEBPACK FOOTER //
// ./src/pages/liveroomLecturer/LiveroomLecturerManage.js